export default __webpack_public_path__ + "static/media/final logo.97a6b827.ico";